import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managerAdd'

export default (data) => (asyncAction(
  name,
  ManagersService.add,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managerAdd.js